const togglePasswordInput = (passwordInputType: string) => {
  return passwordInputType === 'password' ? 'text' : 'password'
}

const generateRandomPassword = () => {
  return Math.random().toString(36).slice(-8) + Math.random().toString(36).slice(-8)
}

export { togglePasswordInput, generateRandomPassword }
